import { render, staticRenderFns } from "./AboutEmpStyle.vue?vue&type=template&id=450df809&"
import script from "./AboutEmpStyle.vue?vue&type=script&lang=js&"
export * from "./AboutEmpStyle.vue?vue&type=script&lang=js&"
import style0 from "./AboutEmpStyle.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports